import LandingPage from './LandingPage'

const PergolaLanding = () => (
  <LandingPage
    image="/landings/pergola-landing.jpg"
    alt="Your Private Miami Oasis — Redefine Your Backyard with a Custom Pergola"
    formUrl="/landing-pergola-form"
    title="Pergola Services"
    headline="Your Private Miami Oasis."
    subtitle="Redefine your backyard. We design and build custom pergolas — wood and aluminum — engineered for South Florida weather, fully permitted, and tailored to your lifestyle."
    features={['Wood Pergola', 'Aluminum Pergola', 'Covered Patio', 'Custom Design']}
    cta="GET YOUR ALUMINUM PERGOLA QUOTE NOW!"
  />
)

export default PergolaLanding
